"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmail = void 0;
const constants_1 = require("../../constants");
const isEmail = (value) => !!value.match(constants_1.REG_EXP_LIST.email);
exports.isEmail = isEmail;
//# sourceMappingURL=isEmail.js.map